var _path, _circle, _ellipse, _path2, _path3, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _circle2, _circle3, _path4, _path5, _path6, _polygon, _path7, _path8, _circle4, _path9, _polygon2, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 781.72276,
    height: 638.34614,
    viewBox: "0 0 781.72276 638.34614",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.85617,674.9065c49.33789-25.57617,151.32971-68.48291,280.06924-68.48291s230.7312,42.90674,280.06909,68.48291c48.03223,24.89966,86.66126,54.25775,104.85785,78.2113,6.633-9.02789-3.10223-169.64245-30.04388-233.33972A516.23463,516.23463,0,0,0,482.7452,204.22292,273.27037,273.27037,0,0,0,288.23983,284.7898q-1.62354,1.62355-3.21667,3.26932c-57.01738,58.89944-83.64048,140.84439-73.92029,222.24249,6.92036,57.952,23.97575,179.16519,48.07419,204.86612A458.81386,458.81386,0,0,1,323.85617,674.9065Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#f2f2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 484.29088,
    cy: 75.15989,
    r: 73.73605,
    fill: "#6c63ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400.52003,
    cy: 498.24604,
    rx: 81.96896,
    ry: 17.1001,
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M692.92877,242.72292c-75.14014-.00677-133.99878-13.62878-133.9972-31.01208.00092-10.42188,20.85773-19.71883,57.22229-25.50608a1,1,0,1,1,.33069,1.97248l-.00378.00062-.01264.002c-34.25537,5.452-55.5357,14.46863-55.53656,23.53113-.0014,15.71973,60.44587,29.00545,131.99738,29.0119s132.00122-13.26837,132.00262-28.9881c.0008-9.10058-21.41388-18.143-55.88751-23.59781a1.00008,1.00008,0,1,1,.30249-1.97715l.00324.0005.007.0011c36.59051,5.78992,57.5758,15.11114,57.57483,25.57355C826.93,229.11826,768.0689,242.72965,692.92877,242.72292Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M698.2843,230.81126c-64.74915,38.12594-122.37849,56.25763-131.19872,41.27822-5.28806-8.98064,7.96558-27.57583,36.36281-51.01663a1,1,0,1,1,1.28592,1.5318l-.00294.00246-.00987.00813c-26.75,22.08157-40.51077,40.65014-35.91251,48.45942,7.97616,13.54587,66.80371-5.68177,128.4605-41.98685s107.00762-78.42029,99.03146-91.96615c-4.61764-7.84207-27.65875-4.7662-60.13169,8.0281a1.00008,1.00008,0,1,1-.74271-1.85716l.003-.0012.0066-.00262c34.46706-13.57981,57.27967-16.19754,62.58824-7.18195C806.8446,151.08626,763.03344,192.68529,698.2843,230.81126Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.83989,
    cy: 498.0995,
    rx: 55.60471,
    ry: 9.2179,
    fill: "#e6e6e6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.51991,
    cy: 585.24891,
    rx: 93.55163,
    ry: 19.51648,
    fill: "#f2f2f2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 598.52003,
    cy: 609.24604,
    rx: 139.49066,
    ry: 29.1001,
    fill: "#f2f2f2"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.23514,
    cy: 584.62159,
    rx: 71.71089,
    ry: 11.88794,
    fill: "#e6e6e6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 598.5508,
    cy: 607.39741,
    rx: 122.60254,
    ry: 20.32446,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.78679,
    cy: 316.89595,
    r: 7,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 547.78682,
    cy: 418.89595,
    r: 7,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M517.85816,325.80308c16.99466,4.84979,16.3416,15,36.5,15s36.5,2.67312,36.5-15-8.0234-50.52667-36.5-49C523.709,278.44624,507.55448,322.86271,517.85816,325.80308Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M473.13265,475.45634a10.74266,10.74266,0,0,1,6.25284-15.23975l41.81616-88.459,19.12793,13.413L493.211,467.90525a10.80091,10.80091,0,0,1-20.07831,7.551Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M508.96459,383.50187a4.81162,4.81162,0,0,1,.5521-3.97272l13.00143-20.38208A13.37737,13.37737,0,0,1,546.974,369.997l-6.54913,23.35315a4.81691,4.81691,0,0,1-6.60406,3.09632l-22.20856-9.93085A4.81153,4.81153,0,0,1,508.96459,383.50187Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#6c63ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "415.837 515.575 404.317 519.77 382.656 477.332 399.658 471.141 415.837 515.575",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M604.02825,650.30109l22.217-8.08923h0l5.0932,13.98846h0L595.133,669.38276h0A14.88691,14.88691,0,0,1,604.02825,650.30109Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M593.52642,619.55823l-43.88708-76.802a4.822,4.822,0,0,1,.052-4.868l19.76239-32.9371a4.81654,4.81654,0,0,1,8.66077.84149l37.36377,103.46817a4.79865,4.79865,0,0,1-2.46851,5.98968l-13.23926,6.27088a4.77329,4.77329,0,0,1-2.04388.45892A4.84019,4.84019,0,0,1,593.52642,619.55823Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.66188,
    cy: 184.45575,
    r: 24.56104,
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M517.86535,426.53412c-19.34213-42.88855.15735-66.85885,9.43872-75.17337a14.55692,14.55692,0,0,1,9.7301-3.72134H571.6336A14.576,14.576,0,0,1,584.67114,368.734l-23.12958,46.25867-43.488,11.95954Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#6c63ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "336.698 527.172 324.438 527.171 318.606 479.883 336.7 479.884 336.698 527.172",
    fill: "#ffb8b8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M524.81964,654.49506H548.4635V669.3819H509.93279a14.88681,14.88681,0,0,1,14.88685-14.88684Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#2f2e41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M540.6419,639.94623l-19.62854-2.26416a4.81791,4.81791,0,0,1-4.23291-5.339c.00317-.027.00647-.054.01007-.08093l17.51831-131.8999a3.74963,3.74963,0,0,0-.07293-1.37668l-17.60767-72.64475a4.761,4.761,0,0,1,.75366-3.92623c2.73041-3.76423,12.08576-12.53656,39.91437-12.70276h.03a4.83439,4.83439,0,0,1,4.39715,2.82654l3.71222,8.16607a3.76283,3.76283,0,0,0,1.25281,1.51258c5.10956,3.61682,29.862,23.918,15.32782,68.48852-14.28485,43.80734-32.58716,128.85483-36.11121,145.45877a4.79128,4.79128,0,0,1-4.69769,3.81439A4.91793,4.91793,0,0,1,540.6419,639.94623Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M638.28021,321.4473a10.52789,10.52789,0,0,0,.27258,1.635L605.20562,359.79,593.428,357.25175l-6.15387,17.27377,20.41321,6.5198a8,8,0,0,0,9.069-3.15139l31.52106-46.79547a10.49714,10.49714,0,1,0-9.99732-9.65113Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M604.1961,361.34592,596.465,382.71811a4.5,4.5,0,0,1-6.36572,2.431L570.15142,374.402a12.49741,12.49741,0,0,1,8.57117-23.47918l22.13623,4.48211a4.4999,4.4999,0,0,1,3.33728,5.94095Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#6c63ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M582.85815,313.80308h-9.71436l-4.28564-12-.85693,12h-4.64307l-2.5-7-.5,7c-12.15015,5.12668-23.66809,5.26828-34.5,0a26,26,0,0,1,26-26h5A26,26,0,0,1,582.85815,313.80308Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M323.42538,570.72291h-3.5v-3.5a4.5,4.5,0,0,0-9,0v3.5h-3.5a4.5,4.5,0,0,0,0,9h3.5v3.5a4.5,4.5,0,0,0,9,0v-3.5h3.5a4.5,4.5,0,0,0,0-9Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M838.58538,484.88291h-1.82v-1.82a2.34,2.34,0,0,0-4.68,0v1.82h-1.82a2.34,2.34,0,0,0,0,4.68h1.82v1.82a2.34,2.34,0,0,0,4.68,0v-1.82h1.82a2.34,2.34,0,0,0,.00824-4.68Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#ff6584"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M307.58538,363.88291h-1.82v-1.82a2.34,2.34,0,0,0-4.68-.0087v1.82871h-1.82a2.34,2.34,0,0,0-.00821,4.68h1.82821v1.82a2.34,2.34,0,0,0,4.68.0087v-1.82868h1.82a2.34,2.34,0,0,0,.01325-4.68h-.005Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M442.58538,363.88291h-1.82v-1.82a2.34,2.34,0,0,0-4.68-.0087v1.82871h-1.82a2.34,2.34,0,0,0-.00821,4.68h1.82821v1.82a2.34,2.34,0,0,0,4.68.0087v-1.82868h1.82a2.34,2.34,0,0,0,.01325-4.68h-.005Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M907.58538,603.88288h-1.82v-1.82a2.34,2.34,0,0,0-4.68,0v1.82h-1.82a2.34,2.34,0,0,0,0,4.68h1.82v1.82a2.34,2.34,0,0,0,4.68,0v-1.82h1.82a2.34,2.34,0,0,0,0-4.68Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M697.58538,408.88291h-1.82v-1.82a2.34,2.34,0,0,0-4.68,0v1.82h-1.82a2.34,2.34,0,0,0,0,4.68h1.82v1.82a2.34,2.34,0,0,0,4.68,0v-1.82h1.82a2.34,2.34,0,1,0,.00824-4.68Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M376.58538,458.88291h-1.82v-1.82a2.34,2.34,0,0,0-4.68-.0087v1.82871h-1.82a2.34,2.34,0,1,0-.00821,4.68h1.82821v1.82a2.34,2.34,0,0,0,4.68.0087v-1.82868h1.82a2.34,2.34,0,0,0,.00821-4.68Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M382.58538,292.88291h-1.82v-1.82a2.34,2.34,0,0,0-4.68-.0087v1.82871h-1.82a2.34,2.34,0,0,0-.00821,4.68h1.82821v1.82a2.34,2.34,0,0,0,4.68.0087v-1.82868h1.82a2.34,2.34,0,0,0,.00821-4.68h0Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M693.42663,228.32616c-72.43628-36.59033-133.18048-24.70074-133.99719-31.01208.00091-10.42188,20.85772-19.71884,57.22229-25.50609a1,1,0,1,1,.33069,1.97247l-.00379.00063-.01263.002c-34.25537,5.452-55.53571,14.46862-55.53656,23.53112-.00141,15.71973,60.44586,29.00545,131.99737,29.01191S825.428,213.05774,825.42944,197.338c.00079-9.10059-21.41388-18.143-55.88751-23.59781a1.00008,1.00008,0,1,1,.30249-1.97716l.00323.00051.007.00109c36.59051,5.78992,57.57581,15.11115,57.57483,25.57355C827.42791,214.72155,760.4956,262.20527,693.42663,228.32616Z",
    transform: "translate(-209.13862 -130.82693)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCos);
export default __webpack_public_path__ + "static/media/cos.37fbfcdf52b9e7615115045e4c60d5d9.svg";
export { ForwardRef as ReactComponent };